module.exports = __webpack_public_path__ + "img/tutorial_course_02.b349f63f.gif";